import { render } from "./MfJoinError.vue?vue&type=template&id=602d295f&ts=true"
import script from "./MfJoinError.vue?vue&type=script&lang=ts"
export * from "./MfJoinError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__